// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__24bME","notes":"Notes_notes__1h7Rt"};